import { BreadCrumbs } from '@teo/components';
import { useMobile } from '@/util';

export const BreadCrumbsDetails = ({
  prevPathname,
  prevName,
  pathname,
  name,
  parentPathname = '',
  parentName = '',
}) => {
  const isMobile = useMobile();
  return (
    <>
      {!isMobile && (
        <BreadCrumbs>
          <BreadCrumbs.Item to={prevPathname}>{prevName}</BreadCrumbs.Item>
          {parentPathname && parentName && (
            <BreadCrumbs.Item to={parentPathname}>
              {parentName}
            </BreadCrumbs.Item>
          )}
          <BreadCrumbs.Item to={pathname}>{name}</BreadCrumbs.Item>
        </BreadCrumbs>
      )}
    </>
  );
};
